import { Component } from '@angular/core';
import { DataService } from '../services/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-paypal',
  templateUrl: './paypal.component.html',
  styleUrls: ['./paypal.component.css'],
})
export class PaypalComponent {
  url: string = 'paypal';
  data: Array<any> = [];
  payouts: Array<any> = [];
  balances: Array<any> = [];
  transactions: Array<any> = [];
  disputes: Array<any> = [];
  step = 1;
  currency = '';
  balance = 0;

  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Merchant',
      route: '/numbers',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-building-columns',
      bgClass: 'bg-white',
      desc: 'Banks',
      route: '/numbers/finance/plaid',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'Analysis',
      route: '/numbers/finance/analysis',
    },
  ];

  resumenCardsTwo = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Finance',
      route: '/numbers',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-building-columns',
      bgClass: 'bg-white',
      desc: 'Accounting',
      route: '/numbers/accounting',
    },
  ];

  constructor(
    private dataService: DataService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.dataService.getData(this.url).subscribe((response) => {
      console.log('response pay', response);

      if (response.rst) {
        //this.data = response.data;
        this.balances = response.balances.balances;
        this.transactions = response.transactions;
        this.disputes = response.disputes.items;
        this.payouts = response.payouts;
      }
    });
  }

  changeStep(step: number) {
    this.step = step;
  }
}
